import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, DefaultText } from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';

const RuleError = ({ error }) => {
  const { t } = useTranslation();
  return (
    <Block margin={2} xs={11.9} border={borderDefinition('red')} borderRadius={smallBorderRadius} padding={2} width="fit-content">
      <DefaultText color="red">{t(`MEMBERSHIP_RULES.${error}`)}</DefaultText>
    </Block>
  );
};
export default RuleError;
